<h1 class="text-center pt-0">Tidy Ranking</h1>


<form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
  <div class="mt-4">
    <label class="block text-sm font-bold mb-2">Email Address</label>
    <input pInputText id="email" formControlName="email" autocomplete="off" class="w-full" maxlength="250" type="email"
      placeholder="your@email.com" />

    <div class="input-validation" *ngIf="forgotForm.controls['email'].invalid && forgotForm.controls['email'].touched">
      <div *ngIf="forgotForm.controls['email'].hasError('required')">
        What is your email
      </div>
      <div *ngIf="forgotForm.controls['email'].hasError('email')">
        That's not an email
      </div>
    </div>
  </div>

  <div class="mt-8">
    <p-button [label]="submitting ? 'Sending...' : 'Send reset instructions'" type="submit" icon="bi bi-box-arrow-in-right" severity="primary"
      fluid="true" [disabled]="submitting"></p-button>
  </div>

  <div class="mt-6 text-center">
    <a routerLink="/login" class="text-gray-500">Remember your account? Login</a>
  </div>
</form>